import { AddEditData, UtilityService } from "./../../utility.service";
import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";
import { ApiDataService } from "src/app/api-data.service";
import { Location } from '@angular/common';

@Component({
  selector: "app-addpackage",
  templateUrl: "./addpackage.component.html",
  styleUrls: ["./addpackage.component.css"],
})
export class AddpackageComponent implements OnInit, AddEditData {
  constructor(
    private route: ActivatedRoute,
    public utility: UtilityService,
    private dataService: ApiDataService,
    private location: Location,
    private cdref: ChangeDetectorRef,
  ) { }
  // step 1 : Assign section variable correctly
  // Step 2 : If EditMode validate and Bind Html input to this object using template driven forms (2-way Binding ([ngModel]))
  // Step 3 : If any Binary Data is uploaded add it to Binary Array
  // Step 4 : on Submit validate schema to be sent-->if valid upload Binary Array to S3 ,upon succes upload Form Data
  // Step 6 : Reset State of form after submit
  // CamelCase for naming anything

  // select this appropriately
  section = this.utility.apiData.packages;
  object: any;
  isEditMode = false;
  isUploadingData = false;
  isLoadingData = false;
  binaryFiles = [];

  @ViewChild("mainForm", { static: false }) mainForm: NgForm;

  ngOnInit() {
    this.resetForm();
    this.hasData();
  }

  resetForm() {
    this.isUploadingData = false;
    this.isLoadingData = false;
    this.isEditMode = false;
    // change
    this.object = JSON.parse(JSON.stringify(this.section.object));
  }

  loadData(id) {
    //Get Form Data via API
    this.dataService.getData(this.section.ApiUrl, id).subscribe(
      (Response) => {
        if (!this.utility.dovValidateSchema.validate(Response, this.section.schema).valid) {
          swal("No data exists");
          this.location.back();
        }
        this.object = Response;
        this.isLoadingData = false;
        this.freeTrail();
        this.cdref.detectChanges();
        console.log(this.object);
      },
      (error) => {
        console.log(error);
        swal("No data exists");
        this.location.back();
      });
  }

  hasData() {
    this.route.paramMap.subscribe((params) => {
      if (params.get("id") && params.get("id") != "") {
        this.isLoadingData = true;
        this.isEditMode = true;
        this.loadData(params.get("id"));
      }
    });
  }

  assignDate(date, event) {
    this.object[date] = new Date(event).getTime();
  }

  uploadBinaryData() {
    this.object.imageSrc = ""; //only in cases where there is singular binding
    let requests = this.binaryFiles.map((object) => {
      return this.utility.uploadBinaryData(object["name"], object["binaryData"], this.section);
    });
    Promise.all(requests)
      .then((responses) => {
        this.object.imageSrc = responses[0]["name"];
        this.uploadFormData();
      })
      .catch((error) => {
        console.log(error);
        this.isUploadingData = false;
      });
  }

  uploadFormData() {
    //post request here,both add & update are sent as post
    console.log(this.object);
    this.dataService
      .postData(this.section.ApiUrl, JSON.stringify(this.object))
      .subscribe((Response) => {
        this.isEditMode ? swal("Package updated succesfully") : swal("Package added succesfully");
        this.location.back();
      }, (error) => {
        error.status == "406" ? swal("Cannot update,Data Exists for this package") : swal("Failed to process request,please try again");
        this.isUploadingData = false;
      });
  }

  loadBinaryFile(event) {
    if (event.target.files.length > 0) {
      //reset binaryFiles array to this image --> S3 allows to directly upload file object or Blob data,for simplicity here file object is used
      this.binaryFiles = [
        { name: uuidv4(), binaryData: event.target.files[0] },
      ];

      //display selected file in image tag
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); //initiates converting file to blob
      reader.onload = (e) => (this.object.imageSrc = reader.result); // call back after file is converted to Blob
    }
  }

  onSubmit() {
    if (this.mainForm.invalid || this.object.products.length == 0) {
      this.mainForm.form.markAllAsTouched();
      swal("Please enter values in the highlighted fields");
      return false;
    }
    this.isUploadingData = true;
    console.log(this.object);

    if (this.binaryFiles.length > 0) {
      this.uploadBinaryData();
    } else {
      this.uploadFormData();
    }
  }

  onDisable() {
    let object = {
      'packageID': this.object.packageID,
      'status': !this.object.status
    };
    this.isUploadingData = true;
    this.dataService
      .putData(this.section.ApiUrl, JSON.stringify(object))
      .subscribe((Response) => {
        console.log(Response);
        swal("Package Updated Succesfully");
        this.location.back();
      }, (error) => {
        swal("Failed to process request,please try again");
        console.log(error);
        this.isUploadingData = false;
      });
  }

  onDelete() {
    if (!this.object.packageID) {
      swal("No Pacakge Exists with given ID");
      return;
    }
    this.isUploadingData = true;
    this.dataService.deleteData(this.section.ApiUrl, this.object.packageID).subscribe(
      (Response) => {
        console.log(Response);
        swal("Package Deleted Succesfully");
        this.location.back();
      },
      (error) => {
        swal("Failed to process request,please try again");
        console.log(error);
        this.isUploadingData = false;
      });
  }

  // special functions
  addOn(item) {
    if (item.form.invalid) {
      item.form.markAllAsTouched();
      swal("Please enter values in the highlighted fields");
      return false;
    }
    item.form.value.addOnId = uuidv4();
    item.form.value.dateUpdated = Date.now();
    this.object.addOnList.push(item.form.value);
    item.form.reset();
  }

  deleteAddOn(item) {
    this.object.addOnList = this.object.addOnList.filter(value => value.addOnId !== item.addOnId)
    console.log(this.object.addOnList);
  }

  addProducts(event, item) {
    if (event.target.checked) {
      this.object.products.push(item);
    } else {
      this.object.products = this.object.products.filter(value => value !== item)
    }
  }

  freeTrail() {
    if (!this.object.isFreeTrail) return;
    this.object.packagePrice = 0;
    this.object.addOnList = [];
  }
}
